// @flow
import * as React from 'react';
import first from 'lodash/fp/first';
import omit from 'lodash/omit';

import { StyledFormError } from '@styles/errors';
// import { getInternationalPhone } from '@services/phone';

import flagsImg from '@images/flags.png';

import type { Props } from './types';
import { StyledInputPhone } from './styles';

const InputPhone = ({
  field, onChange, error, greyBlue, ...rest
}: Props) => {
  const errorString = Array.isArray(error) ? first(error) : error;

  const listStyle = {
    zIndex: 20,
    backgroundColor: 'white',
    color: 'black !important'
  };

  return (
    <>
      <StyledInputPhone
        {...omit(rest, 'form')}
        defaultCountry="in"
        value={(field || {}).value}
        // preferredCountries={['fr', 'de', 'pl', 'us', 'in']}
        flagsImagePath={flagsImg}
        autoFormat={false}
        onChange={onChange}
        listStyle={listStyle}
        greyBlue={greyBlue} // Gray Background color if true
      />
      {errorString && <StyledFormError>{errorString}</StyledFormError>}
    </>
  );
};

export default InputPhone;
